






























import Vue from 'vue'
import { app } from '@/firebase'
import ResetPassword from '@/components/Login/ResetPassword.vue'

export default Vue.extend({
    name: 'authentication',
    components: { ResetPassword },
    data() {
        return {
            verificationStatus: '',
            passwordResetLink: '',
        }
    },
    computed: {
        mode() {
            return this.$route.query.mode.toString()
        },
        actionCode() {
            return this.$route.query.oobCode.toString()
        },
    },

    mounted() {
        const auth = app.auth()
        if (this.mode === 'verifyEmail') {
            auth.checkActionCode(this.actionCode)
                .then((userInfo) =>
                    auth
                        .applyActionCode(this.actionCode)
                        .then(() => {
                            this.verificationStatus = 'success'
                            app.functions()
                                .httpsCallable('onCallPasswordReset')({
                                    email: userInfo.data?.email,
                                })
                                .then((res) => {
                                    this.passwordResetLink = res.data.link || ''
                                })
                                .catch((error) => console.log(error))
                        })
                        .catch(() => {
                            this.verificationStatus = 'failed'
                            this.passwordResetLink = 'mailto:itservice.tsinghua-alumni.de'
                        })
                )
                .catch(() => {
                    console.log('Invalid authentication code.')
                    this.verificationStatus = 'failed'
                    this.passwordResetLink = 'mailto:itservice.tsinghua-alumni.de'
                })
        } else {
            console.log('Invalid action mode.')
        }
    },
})
